import React from 'react';


function AboutAward() {
  return (
    <div>
    <div className="main-content">
    <div className="content-overlay">
      <h1 className="main-title"> О Международной Премии</h1>
      <h1 className="main-title">“Олимп Красоты”</h1>
    </div>
    </div>
    <section className='main-section'>
          <div className='wrapper'>
    <div className='title'>О премии</div>
    <div className='text mb-50'>Учреждение Международной Премии инициировано Международной Ассоциацией Красоты и Ухода (International Association of Beauty and Care) в 2019 году. Премия призвана выделить выдающихся специалистов в индустрии красоты и эстетической медицины, а также специалистов, внесших свой неоспоримый вклад в развитие отрасли красоты и эстетической медицины.</div>
    <div className='text mb-50'>Лидеров в индустрии красоты ежегодно подбирает высококвалифицированный экспертный совет, в котором собраны передовые специалисты в области красоты и эстетической медицины: известные руководители ведущих мировых салонов красоты, знаменитые практикующие специалисты в этой области и признанные эксперты индустрии.</div>
    <div className='text'>Для участия в престижной Международной премии “Олимп красоты” допускаются высокопрофессиональные деятели индустрии красоты и эстетической медицины с опытом работы не менее трех лет, обладающие выдающимися способностями в соответствии со своей специализацией:</div>
    </div>
    <section className='about-section'>
        <div className='wrapper'>
          <div className='title'>Парикмахеры и стилисты</div>
          <ul className="styled-list">
          <li>
            <div className="list-item-container">
              <span className="big-number">1</span>
              <span>Мастерство в создании инновационных и трендовых причесок, сочетающее техническую грамотность и творческий подход;</span>
            </div>
          </li>
          <li>
            <div className="list-item-container">
              <span className="big-number">2</span>
              <span>Умение работать с различными текстурами волос и создавать уникальные образы, подходящие для любого события и личности клиента.</span>
            </div>
          </li>
        </ul>
        </div>
      </section>
      <section className='about-section'>
        <div className='wrapper'>
          <div className='title'>Make-up артисты</div>
          <ul className="styled-list">
          <li>
            <div className="list-item-container">
              <span className="big-number">1</span>
              <span>Мастерство в создании инновационного и трендового макияжа, сочетающее техническую точность и креативный подход;</span>
            </div>
          </li>
          <li>
            <div className="list-item-container">
              <span className="big-number">2</span>
              <span>Умение работать с различными типами кожи и чертами лица, создавая уникальные образы, которые идеально подходят для любого события и подчеркивают индивидуальность клиента.</span>
            </div>
          </li>
        </ul>
        </div>
      </section>
      <section className='about-section'>
        <div className='wrapper'>
          <div className='title'>Мастера маникюра и педикюра</div>
          <ul className="styled-list">
          <li>
            <div className="list-item-container">
              <span className="big-number">1</span>
              <span>Превосходные навыки в техниках маникюра и педикюра, включая арт-дизайн ногтей и спа-процедуры;</span>
            </div>
          </li>
          <li>
            <div className="list-item-container">
              <span className="big-number">2</span>
              <span>Способность к детальной и аккуратной работе, подчеркивающей красоту и здоровье ногтей клиентов.</span>
            </div>
          </li>
        </ul>
        </div>
      </section>
      <section className='about-section'>
        <div className='wrapper'>
          <div className='title'>Косметологи и эстетист</div>
          <ul className="styled-list">
          <li>
            <div className="list-item-container">
              <span className="big-number">1</span>
              <span>Понимание сложных кожных состояний и умение предлагать персонализированные решения для ухода за кожей;</span>
            </div>
          </li>
          <li>
            <div className="list-item-container">
              <span className="big-number">2</span>
              <span>Опыт работы с передовым косметологическим оборудованием и продуктами, обеспечивающими результаты на высоком уровне.</span>
            </div>
          </li>
        </ul>
        </div>
      </section>
      <section className='about-section'>
        <div className='wrapper'>
          <div className='title'>Мастера перманентного макияжа</div>
          <ul className="styled-list">
          <li>
            <div className="list-item-container">
              <span className="big-number">1</span>
              <span>Глубокие знания анатомии лица и цветоведения, необходимые для создания долговременного макияжа, который гармонично вписывается в образ клиента</span>
            </div>
          </li>
          <li>
            <div className="list-item-container">
              <span className="big-number">2</span>
              <span>Уверенное владение техниками перманентного макияжа, обеспечивающее естественные и стойкие результаты.</span>
            </div>
          </li>
        </ul>
        </div>
      </section>
      <section className='about-section'>
        <div className='wrapper'>
          <div className='title'>Тату-мастера</div>
          <ul className="styled-list">
          <li>
            <div className="list-item-container">
              <span className="big-number">1</span>
              <span>Артистизм и техническая мастерство в создании татуировок, выражающих индивидуальность и имеющих художественное значение;</span>
            </div>
          </li>
          <li>
            <div className="list-item-container">
              <span className="big-number">2</span>
              <span>Знание гигиенических стандартов и безопасности процедур, гарантирующее здоровье и удовлетворение клиентов.</span>
            </div>
          </li>
        </ul>
        </div>
      </section>
      <section className='about-section'>
          <div className='wrapper'>
    <div className='text mb-50'>Участники должны продемонстрировать не только высокий уровень профессиональной компетенции, но и способность вносить инновации в свою область, тем самым формируя будущее индустрии красоты и эстетической медицины, <b>к участию в премии допускаются специалисты, которые имеют опыт работы в отрасли не менее трех лет.</b> </div>
    <div className='text mb-50'>Международная Премия "Олимп красоты" занимает почетное место в мире индустрии красоты и эстетической медицины, открывая мастерам двери в мир больших возможностей. Это своего рода Олимп для профессионалов, стремящихся не просто следовать трендам, а создавать их. Международная Премия "Олимп красоты" — это мост между культурами и континентами, где талант и инновации встречают признание на самом высоком уровне.</div>
    <div className='text mb-50'>Получение этой престижной награды не только подчеркивает вклад лауреатов в расцвет индустрии, но и является олицетворением их неиссякаемого стремления к совершенству и красоте. Каждая статуэтка "Олимп красоты" символизирует границы мастерства и креативность, которая вдохновляет на новые открытия и достижения.</div>
    <div className='text mb-50'>Международная Премия "Олимп красоты"- это глобальное международное признание, что делает эту премию одним из наиболее значимых и ожидаемых событий в календаре красоты и эстетики.</div>
    <div className='text mb-50'>География премии охватывает такие страны, как Россия, Украина, Азербайджан, Армения, Беларусь, Казахстан, Киргизия, Молдова, Таджикистан, Туркменистан и Узбекистан.</div>
    </div>
    </section>
    <section className='about-section'>
          <div className='wrapper'>
    <div className='title'>Международное признание </div>
    <div className='text mb-50'>Получение такого престижного приза, как Международная Премия "Олимп красоты", является символом признания на мировой арене, что раскрывает перед обладателями новые перспективы. Специалисты в сфере красоты и эстетической медицины, удостоенные этой награды, получают шанс вступить в международное профессиональное сообщество, принимать участие в глобальных проектах и инициативах, а также привлекать внимание к своим идеям и проектам на всемирном уровне.</div>
    </div>
    </section>
    <section className='about-section'>
          <div className='wrapper'>
    <div className='title'>Престиж и профессиональный рост</div>
    <div className='text mb-50'>Для профессионалов в области красоты и эстетической медицины СНГ победа в Международной Премии "Олимп красоты" является подтверждением их выдающихся навыков и творческого потенциала. Это значительно увеличивает их авторитет в профессиональном сообществе, открывая перед ними новые горизонты для профессионального и личностного роста. Эта награда стимулирует к дальнейшему развитию и совершенствованию, побуждая к поиску инновационных идей и решений в сфере красоты и эстетической медицины.</div>
    </div>
    </section>
    </section>
    </div>
  );
}

export default AboutAward;
